(function () {
  const STORAGE_KEY = 'dairymind-pricing-context';
  const ATTRIBUTION_KEYS = ['gclid', 'fbclid', 'msclkid', 'ttclid'];

  function readStoredContext() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function wholeNumber(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  }

  function readContext() {
    const params = new URLSearchParams(window.location.search);
    const stored = readStoredContext() || {};
    const farmType = params.get('farm_type') || stored.farmType || '';
    const herdSize = wholeNumber(params.get('herd_size') || stored.herdSize);
    const orderQuantity = wholeNumber(params.get('order_quantity') || stored.orderQuantity);
    const productInterest = String(params.get('product_interest') || stored.productInterest || '').toLowerCase();
    const recommendedPath = String(params.get('recommended_path') || stored.recommendedPath || '').toLowerCase();
    const hasLegacyPricingContext = ['monitoring', 'feeding', 'both'].includes(productInterest);
    const hasPlanRecommendation = orderQuantity >= 10 && ['ownership', 'combine'].includes(recommendedPath);
    const hasPricingContext = herdSize >= 10 && (hasLegacyPricingContext || hasPlanRecommendation);
    const entrySource = params.get('entry_source') || (hasPricingContext ? 'pricing' : 'direct');
    const attribution = {};

    params.forEach(function (value, key) {
      if (key.indexOf('utm_') === 0 || ATTRIBUTION_KEYS.includes(key.toLowerCase()) || key === 'experiment_group') {
        attribution[key] = value;
      }
    });

    return {
      entrySource: entrySource,
      farmType: farmType,
      herdSize: herdSize,
      orderQuantity: orderQuantity,
      productInterest: productInterest,
      recommendedPath: recommendedPath,
      hasPricingContext: hasPricingContext,
      attribution: attribution
    };
  }

  function emit(name, detail) {
    const payload = Object.assign({ event: name }, detail || {});
    window.dispatchEvent(new CustomEvent('dairymind:commercial', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  window.DairyMindCommercial = {
    emit: emit,
    readContext: readContext
  };
})();
